import styled from '@emotion/styled';

import { linkWithUnderlineHover } from 'styles/mixins';
import { breakpoints } from '../../styles/basic';

const Wrapper = styled.div`

`;

const TabsWrapper = styled.section`
  margin-top: 4rem;

  .react-tabs__tab-list {
    display: flex;
    gap: 1rem;
    margin: 0;
    list-style: none;
  }
  .react-tabs__tab {
    margin-bottom: -.3rem;
    padding: 1rem;
    border: .3rem solid ${(props) => props.theme.color.gray};
    border-radius: .5rem .5rem 0 0;
    background: ${(props) => props.theme.color.gray};
    text-align: center;
    cursor: pointer;

    &:focus-visible {
      border: .3rem solid ${(props) => props.theme.colorMono.black};
      outline: none;
    }

    @media (min-width: ${breakpoints.smallTablet}) {
      padding-right: 2rem;
      padding-left: 2rem;
    }

  }
  .react-tabs__tab--selected {
    position: relative;
    z-index: 2;
    border: .3rem solid ${(props) => props.theme.colorMono.black};
    background: ${(props) => props.theme.colorMono.white};
    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: -.3rem;
      left: 0;
      height: .3rem;
      background: ${(props) => props.theme.colorMono.white};
    }
  }
  .react-tabs__tab-panel--selected {
    position: relative;
    z-index: 1;
    padding: 2rem;
    border: .3rem solid ${(props) => props.theme.colorMono.black};
    border-radius: 0 .5rem .5rem;
  }
  table {
    width: 100%;
    margin-bottom: 0;
    td {
      padding: 1rem;
    }
    td:first-of-type {
      width: 40%;

      @media (min-width: ${breakpoints.smallTablet}) {
        width: 20rem;
      }
    }
  }
  p:last-of-type {
    margin-bottom: 0;
  }
`;

const People = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  a {
    display: inline-block;
    ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.primary)};
  }
`;

const DetailsList = styled.ul`
  margin: 0 0 2rem;
  list-style: none;
`;

const DetailsListItem = styled.li`

`;

const DateWrapper = styled.div`
  display: flex;
  flex-flow: column wrap;

  @media (min-width: ${breakpoints.smallTablet}) {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
`;

const SecondaryDate = styled.span`
  display: block;

  @media (min-width: ${breakpoints.smallTablet}) {
    &::before {
      content: '/';
      margin-right: 1rem;
    }
  }
`;

const DescriptionWrapper = styled.div`
  display: block;
`;

export {
  Wrapper,
  TabsWrapper,
  People,
  DetailsList,
  DetailsListItem,
  DateWrapper,
  SecondaryDate,
  DescriptionWrapper
};
